import React, {FC} from 'react';
import {Stack} from "@mui/material";
import SelectPerPage from "@ui/select/base/selectPerPage/SelectPerPage";
import {IQueryParamsContext} from "@hooks/query/types/queryParams";
import {useTranslation} from "react-i18next";
import {IDeviceActivityTransform, StatusDeviceActivity} from "@containers/device/containers/deviceActivity/types";
import SelectStatusDeviceActivity from "@containers/device/containers/deviceActivity/select/SelectStatusDeviceActivity";
import {SetStatePropsType} from "@baseTypes/base";
import SelectGroupNameByDeviceActivity
    from "@containers/device/containers/deviceActivity/listDeviceActivity/select/selectGroupNameByDeviceActivity/SelectGroupNameByDeviceActivity";
import ButtonCustom from "@ui/buttons/buttonCustom/ButtonCustom";
import UpdateIcon from '@mui/icons-material/Update';

interface IProps {
    params: IQueryParamsContext<IDeviceActivityTransform>,
    disabled?: boolean,
    targetStatus: StatusDeviceActivity | '0',
    setTargetStatus: (value: StatusDeviceActivity | '0') => void,
    targetGroupIds: string[],
    setTargetGroupIds: SetStatePropsType<string[]>,
    groups:string[],
    onRefetch:()=>void
}

const HeadSidebar: FC<IProps> = ({
                                     params,
                                     disabled,
                                     targetStatus,
                                     setTargetStatus,
                                     targetGroupIds,
                                     setTargetGroupIds,
                                     groups,
                                     onRefetch,
                                 }) => {

    const {
        perPage,
        setPerPage,
        setPage
    } = params;

    const {t} = useTranslation()

    return (
        <Stack
            gap={'5px'}
            direction={'row'}
            flexWrap={'wrap'}
            sx={{
                padding:'10px 0'
            }}
            alignItems={'center'}
        >

            <ButtonCustom
                startIcon={<UpdateIcon fontSize={'small'}/>}
                onClick={onRefetch}
                disabled={disabled}
                variant={'contained'}
            >
                {t('update')}
            </ButtonCustom>

            <SelectGroupNameByDeviceActivity
                value={targetGroupIds}
                onChange={setTargetGroupIds}
                groups={groups}
                width={250}
            />
            <SelectStatusDeviceActivity
                disabled={disabled}
                value={targetStatus}
                hasAllVariant
                onChange={setTargetStatus}
                width={200}
            />
            <SelectPerPage
                width={180}
                perPage={perPage}
                setPerPage={setPerPage}
                setPage={setPage}
                disabled={disabled}
            />

        </Stack>
    );
};

export default HeadSidebar;